

    export default {
        name: "Alert",

        props: {
            message: String,
            type: String,
            autohide: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            formattedMessage() {
                // Replace all types of newlines with <br>
                return (this.message || '').replace(/(\r\n|\n|\r)/g, '<br>');
            }
        },

        watch: {
            message() {
                this.setAutohide()
            }
        },

        created() {
            this.timeout = null
            this.setAutohide()
        },

        methods: {
            setAutohide() {
                clearTimeout(this.timeout)
                if (this.autohide) {
                    this.timeout = setTimeout(() => {
                        this.$emit('update:errorMessage', '');
                    }, 10000)
                }
            }
        }
    }
